import Vue from 'vue'
import VueRouter from 'vue-router'
import VueWechatTitle from 'vue-wechat-title'


Vue.use(VueWechatTitle)



Vue.use(VueRouter)


const routes = [
    {
        path: '/distDegree',
        name: 'distDegree',
        component: () => import('./views/academicDegree'),
        meta:{
            title: '学位占用查询',
        }
    },

    {
        path: '/distTransfer',
        name: 'distTransfer',
        component: () => import('./views/transferApplication'),
        meta:{
            title: '转学申请',
        }
    },
    {
        path: '/distGuide',
        name: 'distGuide',
        component: () => import('./views/businessGuide'),
        meta:{
            title: '办事指南',
        }
    },
    {
        path: '/bgsecond',
        name: 'bgsecond',
        component: () => import('./views/bG-second'),
        meta:{
            title: '办事指南详情',
        }
    },

    {
        path: '/distRecruitStudents',
        name: 'distRecruitStudents',
        component: () => import('./views/enrollmentPolicy'),
        meta:{
            title: '招生政策',
        }
    },
    {
        path: '/epsecond',
        name: 'epsecond',
        component: () => import('./views/eP-second'),
        meta:{
            title: '招生政策详情',
        }
    },
    {
        path: '/distWarningInfo',
        name: 'distWarningInfo',
        component: () => import('./views/enrollmentWarning'),
        meta:{
            title: '招生预警信息',
        }
    },


    {
        path: '/ewSecond',
        name: 'ewSecond',
        component: () => import('./views/eW-second'),
        meta:{
            title: '招生预警信息详情',
        }
    },

    {
        path:'/waringmap',
        name:'waringmap',
        component:() => import('./views/waringMap'),
        meta:{
            title: '预警地图',
        }
    },
    {
        path:'/freedegree',
        name:'freedegree',
        component:() => import('./views/freeDegree'),
        meta:{
            title: '空余学位查询',
        }
    },
    {
        path:'/application',
        name:'application',
        component:() =>import('./views/application'),
        meta:{
            title: '转学申请',
        }
    },


];

const router = new VueRouter({
    routes
})


export default router


